import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useConfirmation = () => {
  const { t } = useTranslation();
  const [confirmationState, setConfirmationState] = useState({
    open: false,
    title: '',
    message: '',
    type: 'warning',
    confirmText: t('common.confirm'),
    cancelText: t('common.cancel'),
    confirmColor: 'primary',
    onConfirm: () => {}
  });

  const showConfirmation = ({
    title = t('common.confirmAction'),
    message = t('common.confirmMessage'),
    type = 'warning',
    confirmText = t('common.confirm'),
    cancelText = t('common.cancel'),
    confirmColor = 'primary',
    onConfirm = () => {}
  }) => {
    setConfirmationState({
      open: true,
      title,
      message,
      type,
      confirmText,
      cancelText,
      confirmColor,
      onConfirm
    });
  };

  const hideConfirmation = () => {
    setConfirmationState(prev => ({ ...prev, open: false }));
  };

  // Convenience methods for common confirmation types
  const confirmDelete = (itemName, onConfirm) => {
    showConfirmation({
      title: t('common.delete'),
      message: t('common.confirmMessage'),
      type: 'error',
      confirmText: t('common.delete'),
      confirmColor: 'error',
      onConfirm
    });
  };

  const confirmSave = (onConfirm) => {
    showConfirmation({
      title: t('common.save'),
      message: t('common.confirmMessage'),
      type: 'info',
      confirmText: t('common.save'),
      confirmColor: 'primary',
      onConfirm
    });
  };

  const confirmLogout = (onConfirm) => {
    showConfirmation({
      title: t('auth.logout'),
      message: t('common.confirmMessage'),
      type: 'warning',
      confirmText: t('auth.logout'),
      cancelText: t('common.cancel'),
      confirmColor: 'warning',
      onConfirm
    });
  };

  return {
    confirmationState,
    showConfirmation,
    hideConfirmation,
    confirmDelete,
    confirmSave,
    confirmLogout
  };
};

export default useConfirmation;
